import { usePartnerId, useRetailerId } from '@retailer-platform/dashboard/routing'
import { type GetRequestContextsQueryVariables, useGetRequestContextsQuery } from '.'

export const useGetRequestContexts = () => {
  const retailerId = useRetailerId()
  const partnerId = usePartnerId()

  const variables: GetRequestContextsQueryVariables = {
    retailerId: parseInt(retailerId),
    partnerId: parseInt(partnerId),
  }

  const {
    data,
    error: apiError,
    loading: apiLoading,
  } = useGetRequestContextsQuery({
    variables,
  })

  const requestContexts = data?.connectPlatformServiceGetRequestContexts?.requestContexts

  return {
    requestContexts,
    requestContextsError: apiError,
    requestContextsLoading: apiLoading,
  }
}
